import axios from 'axios'

import {
  SETTING_ADD_REQUEST,
  SETTING_ADD_SUCCESS,
  SETTING_ADD_FAIL,
  SETTING_LIST_REQUEST,
  SETTING_LIST_SUCCESS,
  SETTING_LIST_FAIL,
  SETTING_UPDATE_REQUEST,
  SETTING_UPDATE_SUCCESS,
  SETTING_UPDATE_FAIL
} from '../constants/settingConstants'
import { API_URL } from '../apiUrl.js'

export const addSettings = (settings) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: SETTING_ADD_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/setting/add`,
      settings,
      config
    )

    dispatch({ type: SETTING_ADD_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: SETTING_ADD_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const getSettings = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: SETTING_LIST_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/setting/list`, config)

    dispatch({ type: SETTING_LIST_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: SETTING_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const updateSettings =
  ({ taxrate, currency, _id }) =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: SETTING_UPDATE_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      const { data } = await axios.put(
        `${API_URL}/setting/update/${_id}}`,
        { taxrate, currency },
        config
      )

      dispatch({ type: SETTING_UPDATE_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: SETTING_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }
